import React from "react";
import MUILink from "@material-ui/core/Link";

import { Link } from "../../../../../../routes";
import { useRouter } from "../../../../../../lib/routerContext";
import { addOrientationParam } from "../helpers";
import { Orientation } from "../constants";
import { RouteParams } from "../types";

interface LinkOptionProps {
  orientation: Orientation;
}

const LinkOption: React.FC<LinkOptionProps> = ({ children, orientation }) => {
  const router = useRouter<RouteParams>();
  return (
    <Link
      route={addOrientationParam(orientation, router)}
      passHref={true}
      shallow={true}
      scroll={false}
    >
      <MUILink rel="nofollow">{children}</MUILink>
    </Link>
  );
};

export { LinkOption };
